/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AuditAuthorType = {
    System: 'SYSTEM',
    Admin: 'ADMIN',
    CustomerUser: 'CUSTOMER_USER',
    CarrierUser: 'CARRIER_USER',
    Driver: 'DRIVER'
} as const;
export type AuditAuthorType = typeof AuditAuthorType[keyof typeof AuditAuthorType];

